import React from "react";
import { Button, Col, Form, Input, message, Rate, Row, Typography } from "antd";
import AvatarPreview from "../profile/components/AvatarPreview";
import { ReactComponent as SendRocket } from "../../images/chat/send-rocket.svg";
import { rateToConsultionService } from "../consulting/consulting.api";
import { rateToSupportService } from "../supports/support.api";
import { useHistory, useParams } from "react-router-dom";

const { Paragraph } = Typography;
const { TextArea } = Input;

export default function RateToConversion({
  getSessionDetail,
  closeBottomSheet,
  isTicket,
  userInfo = {
    avatarImage: "ADMIN",
    name: "",
    description: "",
  },
}) {
  const { sessionId, id } = useParams();

  const [form] = Form.useForm();

  const history = useHistory();

  function handleSubmitForm(values) {
    if (!isTicket) {
      rateToConsultionService({ ...values, sessionId })
        .then(() => {
          message.success("نظر شما با موفقیت ثبت شد");
          closeBottomSheet();
          getSessionDetail();
          history.push("/home");
        })
        .catch((err) => {
          if (
            err.hasOwnProperty("response") &&
            err.response &&
            err.response.status === 412
          ) {
            message.error("نظر شما به این گفتگو قبلا ثبت شده است.");
            closeBottomSheet();
            return false;
          }

          message.error("خطایی در ارتباط با سرور");
        });
    } else {
      rateToSupportService({ ...values, ticketId: id })
        .then(() => {
          message.success("نظر شما با موفقیت ثبت شد");
          closeBottomSheet();
        })
        .catch((err) => {
          if (
            err.hasOwnProperty("response") &&
            err.response &&
            err.response.status === 412
          ) {
            message.error("نظر شما به این گفتگو قبلا ثبت شده است.");
            closeBottomSheet();
            return false;
          }

          message.error("خطایی در ارتباط با سرور");
        });
    }
  }

  return (
    <>
      <div className="bottom-sheet-bg-holder">
        <div className="bottom-sheet-bg" />
      </div>
      <div className="bottom-sheet-content">
        <div className="avatar-holder">
          <div className="avatar lawyer-avatar">
            <AvatarPreview
              src={userInfo.avatarImage || "LAWONE"}
              isSvg={false}
            />
          </div>
          <SendRocket className="send-rocket" />
        </div>
        <Paragraph className="rate-txt lawyer-name">{userInfo.name}</Paragraph>
        {/* <Paragraph className="rate-txt lawyer-description">
          {userInfo.description}
        </Paragraph> */}
        <Paragraph className="rate-txt description">
          .لطفا به خدمات ارائه شده امتیاز بدهید
        </Paragraph>

        <Form
          onFinish={handleSubmitForm}
          form={form}
          initialValues={{
            comment: "",
            rate: 0,
          }}
        >
          <Form.Item name={isTicket ? "rating" : "rate"} label="">
            <Rate allowHalf name={isTicket ? "rating" : "rate"} />
          </Form.Item>

          <Row>
            <Col span={24}>
              <Paragraph className="rate-txt opinion-title mb-10">
                :لطفا نظرات خود را با ما به اشتراک بگذارید
              </Paragraph>
              <Form.Item name="comment" label="">
                <TextArea
                  rows={3}
                  name="comment"
                  className="opinion-textarea"
                  placeholder="توضیحات..."
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="submit-btn">
                <Button size="small" htmlType="submit">
                  ثبت
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
}
